import { FilterOptionButton } from '@/components/common/FilterButtons';
import { Input } from '@/components/common/Input';
import type { StockFilter } from '@/domain/Stock';

export interface StockFiltersProps {
  filter: StockFilter;
  onFilterChange: (filter: StockFilter) => void;
  search: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const StockFilters = ({
  filter,
  onFilterChange,
  search,
  onSearchChange,
}: StockFiltersProps) => {
  return (
    <div className="flex flex-wrap items-end gap-4 pt-4">
      <div className="flex flex-wrap gap-2">
        <FilterOptionButton
          label="All stock"
          isActive={filter === 'all'}
          onClick={() => onFilterChange('all')}
        />
        <FilterOptionButton
          label="Low stock"
          isActive={filter === 'low'}
          onClick={() => onFilterChange('low')}
        />
        <FilterOptionButton
          label="Out of stock"
          isActive={filter === 'out'}
          onClick={() => onFilterChange('out')}
        />
      </div>
      <Input
        label="Search"
        value={search}
        onChange={onSearchChange}
        className="h-15 w-48 bg-white text-sm"
      />
    </div>
  );
};
